"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../geom/Location"));

var _Position = _interopRequireDefault(require("./Position"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Depth =
/*#__PURE__*/
function () {
  function Depth() {
    _classCallCheck(this, Depth);

    Depth.constructor_.apply(this, arguments);
  }

  _createClass(Depth, [{
    key: "getDepth",
    value: function getDepth(geomIndex, posIndex) {
      return this._depth[geomIndex][posIndex];
    }
  }, {
    key: "setDepth",
    value: function setDepth(geomIndex, posIndex, depthValue) {
      this._depth[geomIndex][posIndex] = depthValue;
    }
  }, {
    key: "isNull",
    value: function isNull() {
      if (arguments.length === 0) {
        for (var i = 0; i < 2; i++) {
          for (var j = 0; j < 3; j++) {
            if (this._depth[i][j] !== Depth.NULL_VALUE) return false;
          }
        }

        return true;
      } else if (arguments.length === 1) {
        var geomIndex = arguments[0];
        return this._depth[geomIndex][1] === Depth.NULL_VALUE;
      } else if (arguments.length === 2) {
        var _geomIndex = arguments[0],
            posIndex = arguments[1];
        return this._depth[_geomIndex][posIndex] === Depth.NULL_VALUE;
      }
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var i = 0; i < 2; i++) {
        if (!this.isNull(i)) {
          var minDepth = this._depth[i][1];
          if (this._depth[i][2] < minDepth) minDepth = this._depth[i][2];
          if (minDepth < 0) minDepth = 0;

          for (var j = 1; j < 3; j++) {
            var newValue = 0;
            if (this._depth[i][j] > minDepth) newValue = 1;
            this._depth[i][j] = newValue;
          }
        }
      }
    }
  }, {
    key: "getDelta",
    value: function getDelta(geomIndex) {
      return this._depth[geomIndex][_Position.default.RIGHT] - this._depth[geomIndex][_Position.default.LEFT];
    }
  }, {
    key: "getLocation",
    value: function getLocation(geomIndex, posIndex) {
      if (this._depth[geomIndex][posIndex] <= 0) return _Location.default.EXTERIOR;
      return _Location.default.INTERIOR;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1) {
        var lbl = arguments[0];

        for (var i = 0; i < 2; i++) {
          for (var j = 1; j < 3; j++) {
            var loc = lbl.getLocation(i, j);

            if (loc === _Location.default.EXTERIOR || loc === _Location.default.INTERIOR) {
              if (this.isNull(i, j)) {
                this._depth[i][j] = Depth.depthAtLocation(loc);
              } else this._depth[i][j] += Depth.depthAtLocation(loc);
            }
          }
        }
      } else if (arguments.length === 3) {
        var geomIndex = arguments[0],
            posIndex = arguments[1],
            location = arguments[2];
        if (location === _Location.default.INTERIOR) this._depth[geomIndex][posIndex]++;
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Depth;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "depthAtLocation",
    value: function depthAtLocation(location) {
      if (location === _Location.default.EXTERIOR) return 0;
      if (location === _Location.default.INTERIOR) return 1;
      return Depth.NULL_VALUE;
    }
  }]);

  return Depth;
}();

exports.default = Depth;

Depth.constructor_ = function () {
  this._depth = Array(2).fill().map(function () {
    return Array(3);
  });

  for (var i = 0; i < 2; i++) {
    for (var j = 0; j < 3; j++) {
      this._depth[i][j] = Depth.NULL_VALUE;
    }
  }
};

Depth.NULL_VALUE = -1;